/**
 * getWithThousandSeparator formats a number with a thousands separator using JavaScript's String object
 * It takes a @number as input and returns the number formatted with thousands separator
 */
const getWithThousandSeparator = (number) => String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

/**
 * getTransformedId transforms a customId into a standardized ID format
 * It takes a @customId as input. If the customId is falsy, it returns null
 * Otherwise, it returns the transformed ID after performing several operations like trimming, replacing certain patterns, and converting to lowercase
 */
const getTransformedId = (customId) => {
    if (!customId) return null;
    return String(customId)
        .toLowerCase()
        .trim()
        .replace(/^\d+\.\s*/, "")
        .replace(/<[^>]*>/g, "")
        .replace(/\s/g, "-")
        .replace(/[^a-zA-Z0-9\-]/g, "")
        .replace(/-+/g, "-")
        .replace(/-$/g, "");
};

/**
 * getPlainId generates a simplified ID from a @title by removing commas and spaces
 */
const getPlainId = (title) => title.toLowerCase().replace(/[,\s]/g, "");

/**
 * getValueFromSlug extracts a value from a @slug and capitalizing each word
 */
const getValueFromSlug = (slug) =>
    slug
        .split("-")
        .map((word) => `${word.charAt(0).toUpperCase() + word.slice(1)}`)
        .join(" ");

export { getWithThousandSeparator, getTransformedId, getPlainId, getValueFromSlug };
